import { render, staticRenderFns } from "./PaginaVendite.vue?vue&type=template&id=24f2ae48&"
import script from "./PaginaVendite.vue?vue&type=script&lang=js&"
export * from "./PaginaVendite.vue?vue&type=script&lang=js&"
import style0 from "./PaginaVendite.vue?vue&type=style&index=0&id=24f2ae48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports